import { api } from '@api/index';
import { Contract } from '@models/contract.types';

export const createContractRequestId = (contractId: string) =>
  `fetch-contract-${contractId}`;

export const createResidentsRequestId = (contractId: string) =>
  `fetch-contract-residents-${contractId}`;

export const fetchContractWithResidents = async (
  contractId: string
): Promise<Contract> => {
  const [contract, residents] = await Promise.all([
    api.contracts.fetchContract(contractId),
    api.residents.fetchResidents(contractId),
  ]);

  return {
    ...contract.data,
    residents: residents.data,
  };
};
